import { Component, Input } from '@angular/core';
import { DataTileModel } from 'libs/portal/src/modules/keepalive/models/DataTile';
import { SegmentedTileModel } from 'libs/portal/src/modules/keepalive/models/SegmentedTile';

@Component({
  selector: 'app-data-tile-list',
  templateUrl: './data-tile-list.component.html',
  styleUrls: ['./data-tile-list.component.scss'],
})
export class DataTileListComponent {
  @Input() title: string | number;
  @Input() status: string;
  @Input() isLoading: boolean;
  @Input() dataTiles: DataTileModel[];
  @Input() segementedTiles: SegmentedTileModel[];
  @Input() segmentedTile: boolean;

  constructor() {}
}
